import Vue from "vue";
import dashboardGraph from "../mixins/dashboardGraph";
import RecentContactActivitiesTable from "../components/tables/RecentContactActivitiesTable";
import RecentCampaignActivitiesTable from "../components/tables/RecentCampaignActivitiesTable";

Vue.component('dashboard', {
  components: { RecentContactActivitiesTable, RecentCampaignActivitiesTable },
  methods: {
    percentage: function (limits) {
      return (limits.current_usage/limits.monthly_limit)*100;
    },
    campaign_token: function (id) {
      return btoa('campaign_id='+id);
    },
    moment: function (date) {
      return moment(date);
    },
    date: function (date) {
      return moment(date).format('MMMM Do, YYYY');
    }
  },
  computed: {
    vueData() {
      return JSON.parse(this.vueDataRaw);
    }
  },
  mixins: [dashboardGraph],
  mounted() {
    this.initDashboardGraph();
  },
  props: ['vueDataRaw', 'vesselId']
});